gsap.config({ trialWarn: false });
gsap.registerPlugin(ScrollTrigger, Flip);

let mm = gsap.matchMedia();
mm.add("(max-width: 767.98px)", () => {
  ScrollTrigger.normalizeScroll(true);
});

function resizeHandler() {

 


  /* Vision Section */


/*
  const visionSection = document.querySelector(".visionSection");
  const visionVideo = document.querySelector(".visionVideo");

  const stateInit = Flip.getState(visionVideo, {
    props: "width,height,top,left",
  });
  visionSection.appendChild(visionVideo);

  gsap.set(visionVideo, {
    width: "95%",
    height: "90%",
    top: "5%",
    left: "2.5%",
    position: "absolute",
  });

  let tl_3 = gsap.timeline({
    scrollTrigger: {
      trigger: ".visionSection",
      start: "top top", 
      end: "bottom top",
      pin: true,
      scrub:4,
      toggleActions: "play none reverse reset",
      //invalidateOnRefresh: true,
    }
  })
  tl_3.add(Flip.from(stateInit, {absolute: true}));

  */


   /* Boundless */

  gsap.from(".boundContent", {
    yPercent:50,
    opacity:0,
    scrollTrigger: {
      trigger:".boundlessSection",
      start:"top bottom",
      end:"top 30%",
      scrub:4,
      //pin:true,
      toggleActions: "play none reverse reset",
      //invalidateOnRefresh: true,
    }
  });

  


}
 
resizeHandler();


window.addEventListener("resize", resizeHandler);


(function($) {
  // Use $ safely inside this function
  $(document).ready(function() {
    /* water ripples */

    $('.boundWaters').ripples({
      resolution: 512,
      dropRadius: 20,
      perturbance: 0.04,
    });
  });
})(jQuery);




